var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.66 30.488L18.822 17.452L10.162 13.359L4 26.395L9.32397 26.339L12.66 30.488Z",
    fill: "#509EC6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1742 30.568L11.9741 17.444L20.6931 13.323L26.8932 26.447L21.5332 26.391L18.1742 30.568Z",
    fill: "#134067"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0579 12.286C27.0579 14.5182 26.3959 16.7002 25.1558 18.5562C23.9157 20.4122 22.1531 21.8587 20.0909 22.7129C18.0286 23.5671 15.7594 23.7906 13.5701 23.3552C11.3808 22.9197 9.3698 21.8448 7.79142 20.2664C6.21305 18.688 5.13815 16.6771 4.70268 14.4878C4.2672 12.2985 4.4908 10.0293 5.34501 7.96704C6.19922 5.90479 7.64578 4.14216 9.50175 2.90204C11.3577 1.66192 13.5397 1 15.7719 1C17.254 0.999869 18.7216 1.2917 20.091 1.85883C21.4603 2.42595 22.7046 3.25727 23.7526 4.3053C24.8006 5.35333 25.6319 6.59755 26.199 7.96689C26.7661 9.33623 27.058 10.8039 27.0579 12.286V12.286Z",
    fill: "#134067"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0502 12.286C25.05 14.121 24.5057 15.9147 23.4861 17.4403C22.4665 18.9659 21.0174 20.1549 19.322 20.857C17.6267 21.5591 15.7612 21.7427 13.9615 21.3846C12.1619 21.0265 10.5088 20.1428 9.2113 18.8452C7.91385 17.5476 7.03028 15.8944 6.67236 14.0947C6.31445 12.2949 6.49818 10.4295 7.20044 8.73422C7.9027 7.03895 9.09194 5.58999 10.6177 4.57056C12.1434 3.55112 13.9371 3.00699 15.7721 3.00699C16.9906 3.00699 18.1972 3.24699 19.3229 3.71332C20.4486 4.17964 21.4715 4.86314 22.333 5.72479C23.1946 6.58644 23.878 7.60936 24.3442 8.73514C24.8104 9.86091 25.0503 11.0675 25.0502 12.286V12.286Z",
    fill: "#13B9B7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4912 17.133L10.8032 13.138L12.4032 11.661L14.6102 14.051L20.4242 8.651L21.9061 10.251L14.4912 17.133Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronIcon);
export default __webpack_public_path__ + "static/media/chevron-icon.50a5a51b.svg";
export { ForwardRef as ReactComponent };